






















import { computed, defineComponent } from '@vue/composition-api';
import { ButtonType } from '@getaccept/lib-ui';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import NameInput from '@getaccept/dsr-shared/src/components/NameInput.vue';
import { DrView } from '@getaccept/dsr-shared';

export default defineComponent({
  name: 'RoomIntro',
  components: {
    NameInput,
  },
  props: {
    drName: {
      type: String,
      default: '',
    },
    editable: {
      type: Boolean,
    },
  },
  setup() {
    const fallBackWelcomeText =
      'The goal of this project is to design and develop a digital sales room that provides a seamless and engaging experience for both sales reps and customers.';

    const roomDescription = computed(() => fallBackWelcomeText);

    return {
      ButtonType,
      DrView,
      t,
      roomDescription,
    };
  },
});
